var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 256C0 397.385 114.615 512 256 512C397.385 512 512 397.385 512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256Z",
    fill: "#1DA1F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M384 176C374.4 180.8 364.8 182.4 353.6 184C364.8 177.6 372.8 168 376 155.2C366.4 161.6 355.2 164.8 342.4 168C332.8 158.4 318.4 152 304 152C270.4 152 244.8 184 252.8 216C209.6 214.4 171.2 193.6 144 161.6C129.6 185.6 137.6 216 160 232C152 232 144 228.8 136 225.6C136 249.6 153.6 272 177.6 278.4C169.6 280 161.6 281.6 153.6 280C160 300.8 179.2 316.8 203.2 316.8C184 331.2 155.2 339.2 128 336C152 350.4 179.2 360 208 360C305.6 360 360 278.4 356.8 203.2C368 196.8 377.6 187.2 384 176Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.2d6361eee996dfc0ba09e3aea8ccaaf4.svg";
export { ForwardRef as ReactComponent };